import { LabelFormData } from "components/Forms/LabelsForm/schema.ts";
import { LabelType } from "types/enums.ts";

export const DEFAULT_VALUES: LabelFormData = {
    name: "",
    type: LabelType.Label,
    country_id: 59,
    color: null,
};
